// src/config.js
var config = {
    baseUrl: 'proximadlt.mooo.com',
};

export default config;
